import { useCallback, useState } from 'react';
import { FlowOrder } from '../pages/timelineFlow';

const KEY = 'v2.timeline.order';

const read = (): FlowOrder => {
    try {
        return window.localStorage.getItem(KEY) === 'time' ? 'time' : 'type';
    } catch {
        return 'type';
    }
};

/** How a timeline is ordered, per type or in time; remembered in this browser, the same on every screen. */
export const useFlowOrder = (): [FlowOrder, (order: FlowOrder) => void] => {
    const [order, setOrder] = useState<FlowOrder>(read);
    const change = useCallback((next: FlowOrder) => {
        setOrder(next);
        try {
            window.localStorage.setItem(KEY, next);
        } catch {
            // Storage that is off only costs remembering the choice.
        }
    }, []);
    return [order, change];
};

/** Type | Tijd, for the head of a timeline. */
export const FlowOrderToggle = ({ order, onChange }: { order: FlowOrder; onChange: (order: FlowOrder) => void }) => (
    <div className="seg sm" role="group" aria-label="Volgorde van de timeline">
        <button className={order === 'type' ? 'on' : ''} onClick={() => onChange('type')} title="Per document, de klant eerst">
            Type
        </button>
        <button className={order === 'time' ? 'on' : ''} onClick={() => onChange('time')} title="Alles op volgorde van tijd">
            Tijd
        </button>
    </div>
);
